import { render } from "./zixun.vue?vue&type=template&id=5746d94e"
import script from "./zixun.vue?vue&type=script&lang=js"
export * from "./zixun.vue?vue&type=script&lang=js"

import "./zixun.vue?vue&type=style&index=0&id=5746d94e&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__